import React, { ComponentType, MouseEvent } from 'react'
import { IconProps } from '@aboutbits/react-material-icons/dist/types'

const SectionTitleWithAction: React.FC<{
  label: string
  buttonIcon: ComponentType<IconProps>
  onClick: (evt: MouseEvent<HTMLButtonElement>) => void
}> = ({ children, buttonIcon: Icon, onClick, label }) => {
  return (
    <div className="px-3 pb-5 text-sm font-medium md:p-5 md:font-bold">
      <div className="flex justify-between">
        <div>{children}</div>
        <button type="button" onClick={(evt) => onClick(evt)}>
          <Icon
            height="24"
            className="fill-current hover:text-gray-600"
            title={label}
          />
        </button>
      </div>
    </div>
  )
}

export { SectionTitleWithAction }
